// ui
import { Typography, Modal, Box } from "@mui/material";
import { useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";
import { PO_MODAL_SX, PO_MODAL_SX_SP } from "../lib/poModalFrame";
import { PoButton } from "./common/PoButton";

interface DataAddModalResultProps {
  onModal: boolean;
  swCloseModal: () => void;
  addModalTitle: string;
  onDataAddModalResult: string;
  /** ★cmd-po_1221 R9: 成功時 rs-title 文言。無指定=登録系default（既存ADD呼出不変）。編集系は"変更を保存しました。"を明示 */
  successMessage?: string;
}

export function DataAddModalResult(props: DataAddModalResultProps) {
  const {
    onModal,
    swCloseModal,
    addModalTitle,
    onDataAddModalResult,
    successMessage = "新規作成に成功しました。",
  } = props;
  // ★cmd-po_1223 R11: sentinel方式。"success:<文言>" 接頭辞でper-call文言をrs-title化（既存 "success"/"failed"/else は不変＝後方互換）
  const isSuccess = onDataAddModalResult === "success" || onDataAddModalResult.startsWith("success:");
  const successTitle = onDataAddModalResult.startsWith("success:") ? onDataAddModalResult.slice("success:".length) : successMessage;
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const style = isSmartPhone ? PO_MODAL_SX_SP : PO_MODAL_SX;
  return (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} data-testid="data-add-result-modal">
        <Typography id="modal-modal-description" sx={{ mt: 0, mb: 0, padding: "var(--sp-4, 16px) var(--sp-5, 24px)" }}>
          {isSuccess ? (
            <>
              {/* result-state ★cmd-po_1196 A1: status-result正規構造（GetXLSXTossUpModal:1073-1082型）へ純再スキン。rs-desc=メッセージ源なしゆえ作らない */}
              <div className="result-state -success" data-testid="result-state-success">
                <span className="rs-icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span className="rs-title">{successTitle}</span>
              </div>
              <Box sx={{ display: "flex", justifyContent: "center", marginTop: "15px", marginBottom: "var(--sp-4, 16px)" }}>
                <PoButton
                  data-testid="data-add-result-success-close"
                  variant="primary"
                  onClick={swCloseModal}
                >
                  閉じる
                </PoButton>
              </Box>
            </>
          ) : onDataAddModalResult === "failed" ? (
            <>
              {/* result-state ★cmd-po_1215 D1: result-failed_pcスライス対称にrs化。rs-title/rs-desc文言はapp固有維持（案B=構図逐語・文言不変） */}
              <div className="result-state -failed" data-testid="result-state-failed">
                <span className="rs-icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                    <path d="m15 9-6 6M9 9l6 6"></path>
                  </svg>
                </span>
                <span className="rs-title">データの登録に失敗しました。</span>
                <span className="rs-desc">いずれかのデータの形式が異なる可能性があります。</span>
              </div>
              <Box sx={{ display: "flex", justifyContent: "center", marginTop: "15px", marginBottom: "var(--sp-4, 16px)" }}>
                <PoButton
                  data-testid="data-add-result-failed-close"
                  variant="primary"
                  onClick={swCloseModal}
                >
                  閉じる
                </PoButton>
              </Box>
            </>
          ) : (
            <>
              <Box>
                {onDataAddModalResult}
              </Box>
              <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: "15px", marginBottom: "var(--sp-4, 16px)" }}>
                <PoButton
                  data-testid="data-add-result-other-close"
                  variant="primary"
                  onClick={swCloseModal}
                >
                  閉じる
                </PoButton>
              </Box>
            </>
          )}
        </Typography>
      </Box>
    </Modal>
  );
}
